import React, { useState, useEffect } from 'react';
import { IconTextButton } from '../Button';
import './SelectionActionBar.css';
// @ts-ignore
import tasksIcon from '../../image-assets/icon.tasks.svg';
// @ts-ignore
import deselectIcon from '../../image-assets/icon.clear.svg';

interface SelectionActionBarProps {
  selectedCount: number;
  onCreateReview: () => void;
  onAddToReview: () => void;
  onDeselectAll: () => void;
  isVisible: boolean;
}

const SelectionActionBar: React.FC<SelectionActionBarProps> = ({
  selectedCount,
  onCreateReview,
  onAddToReview,
  onDeselectAll,
  isVisible,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  
  // Handle animation when visibility changes
  useEffect(() => {
    if (isVisible) {
      // Clear any exit state
      setIsExiting(false);
      // Show the component first
      setShouldRender(true);
      // Then start the animation after a small delay for the DOM to update
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    } else {
      // Start exit animation
      setIsExiting(true);
      setIsAnimating(false);
      // Then remove the component after animation completes
      const timeout = setTimeout(() => {
        setShouldRender(false);
        setIsExiting(false);
      }, 300); // Slightly longer than CSS transition duration
      
      return () => clearTimeout(timeout);
    }
  }, [isVisible]);

  // Determine which sections to show
  const showSelectionSection = selectedCount > 0;
  
  // Don't render if nothing active and not in the middle of animating out
  if (!shouldRender) return null;
  
  // Don't render if no sections are active (shouldn't happen due to isVisible check, but as a safeguard)
  if (!showSelectionSection && !isAnimating && !isExiting) return null;

  // Determine CSS classes based on animation state
  const barClassName = `selection-action-bar ${isAnimating ? 'visible' : ''} ${isExiting ? 'exiting' : ''}`;

  return (
    <div className={barClassName}>
      {/* Selection Actions */}
      {showSelectionSection && (
        <div className="selection-actions">
          <IconTextButton
            variant="text"
            size="medium"
            onClick={onDeselectAll}
            icon={deselectIcon}
            iconAlt="Deselect"
          >
            Deselect {selectedCount} {selectedCount === 1 ? 'key' : 'keys'}
          </IconTextButton>
          <IconTextButton
            variant="text"
            size="medium"
            onClick={onCreateReview}
            icon={tasksIcon}
            iconAlt="Review"
          >
            Review
          </IconTextButton>
        </div>
      )}
    </div>
  );
};

export default SelectionActionBar; 